"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAccessPointSchedulesByUserRoles = selectAccessPointSchedulesByUserRoles;
var hasura_1 = require("../hasura");
var main_api_1 = require("../main-api");
var timetable_verification_1 = require("../timetable-verification");
var isUserRoleAllowedOrDenied_1 = require("./isUserRoleAllowedOrDenied");
var selectValidAccessPointUserRoles_1 = require("./selectValidAccessPointUserRoles");
function selectAccessPointSchedulesByUserRoles(args) {
    var accessPoint = args.accessPoint, userRoles = args.userRoles;
    var validUserRoles = (0, selectValidAccessPointUserRoles_1.selectValidAccessPointUserRoles)(accessPoint, userRoles, {
        includeReservationOnly: args.includeReservationOnly === true,
    });
    var canBypassSchedule = validUserRoles.some(function (u) { return (u.userRolePermissions.some(function (p) { return p.permissionKey === hasura_1.PermissionKey_enum.AccessPoint_BypassSchedule; })); });
    if (canBypassSchedule) {
        // Bypass CONTROLLED and LOCKDOWN schedules, but include UNLOCKED for informational purposes
        var unlockedSchedules = (0, timetable_verification_1.selectUnlockedSchedules)(accessPoint.timetable);
        return unlockedSchedules.length
            // Prepend CONTROLLED 24/7 access schedule to ensure bypassing user
            // can unlock any time outside of UNLOCKED schedules
            ? __spreadArray([__assign({}, timetable_verification_1.CONTROLLED_24_7_SCHEDULE)], unlockedSchedules, true) : null; // Equivalent of 24/7 CONTROLLED access
    }
    var defaultSchedules = [];
    var combinedRoleSchedules = [];
    var controlledSchedules = (0, timetable_verification_1.selectControlledSchedules)(accessPoint.timetable);
    var uncontrolledSchedules = (0, timetable_verification_1.selectUncontrolledSchedules)(accessPoint.timetable);
    for (var _i = 0, validUserRoles_1 = validUserRoles; _i < validUserRoles_1.length; _i++) {
        var userRole = validUserRoles_1[_i];
        var roleSchedules = [];
        // @TODO: How should we handle multiple custom schedules for the same role,
        // but different unit group specifications (no unit group, child unit group, etc.)?
        // Right now we're just combining the custom schedules instead of selecting one.
        for (var _a = 0, _b = accessPoint.accessPointRoles; _a < _b.length; _a++) {
            var accessPointRole = _b[_a];
            var roleSchedule = accessPointRole.schedule;
            if ((0, isUserRoleAllowedOrDenied_1.isUserRoleAllowListed)(accessPointRole, accessPoint, userRole)) {
                if (roleSchedule) {
                    roleSchedules = __spreadArray(__spreadArray([], roleSchedules, true), roleSchedule.map(function (rule) { return (__assign(__assign({}, rule), { state: main_api_1.TimetableRuleState.CONTROLLED })); }), true);
                }
            }
        }
        if (roleSchedules.length) {
            // Apply custom role (CONTROLLED) schedules
            combinedRoleSchedules = __spreadArray(__spreadArray([], combinedRoleSchedules, true), roleSchedules, true);
        }
        else {
            if (!controlledSchedules.length) {
                // If no custom role schedules are applied AND there are no default CONTROLLED
                // schedules, the user has 24/7 access and no other user roles need to be checked.
                return uncontrolledSchedules.length ? uncontrolledSchedules : null;
            }
            // Apply default (CONTROLLED) schedules
            defaultSchedules = controlledSchedules;
        }
    }
    var allCombinedSchedules = __spreadArray(__spreadArray(__spreadArray([], defaultSchedules, true), combinedRoleSchedules, true), uncontrolledSchedules, true);
    return allCombinedSchedules.length ? allCombinedSchedules : null;
}
//# sourceMappingURL=selectAccessPointSchedulesByUserRoles.js.map